import { Box, SxProps, TextFieldProps, Tooltip } from "@mui/material";
import React, { ReactElement } from "react";
import InfoIcon from '@mui/icons-material/Info';
import {StyledAsterisk, StyledTextbox, StyledTextboxErrorMessage, StyledTextboxLabel} from "./Textbox.style";
import { sanitizeInput } from "utils/functions";

export type ITextboxProps = TextFieldProps & {
  toolTip?: string | ReactElement;
  errorMessage?: string;
  isShow?: boolean;
  boldLabel?: boolean;
  disabledBackground?: boolean;
  labelSize?: 'small' | 'medium';
  textboxToolTip?: string;
  style?: SxProps;
  isSpecialCharacterAllowed?: boolean;
}

const Textbox = ({
  variant = "outlined",
  label = "",
  value = "",
  placeholder = "",
  required = false,
  toolTip = "",
  errorMessage = "",
  style = {},
  isShow = true,
  boldLabel = false,
  disabledBackground = false,
  labelSize = "medium",
  textboxToolTip = "",
  isSpecialCharacterAllowed = true,
  ...props
}: ITextboxProps) => {
  if (!isShow) return <React.Fragment></React.Fragment>;
  return (
      <Box sx={style}>
          {label && <StyledTextboxLabel
            bold={boldLabel}
            error={!!props.error}
            fontSize={labelSize}
          >{label} {required && <StyledAsterisk>*</StyledAsterisk>}
              {!!toolTip && (
                <Tooltip
                  title={toolTip}
                  placement="right-start"
                  className="tooltip-container"
                  children={<div><InfoIcon fontSize="small" htmlColor="black" /></div>}
                />
              )}
          </StyledTextboxLabel>}
        <StyledTextbox
        {...props}
        value={value}
        variant={variant}
        required={required}
        placeholder={placeholder}
        error={props.error}
        title={`${!!required ? textboxToolTip : ''}`}
        onChange={(e) => {
          sanitizeInput(e, isSpecialCharacterAllowed);
          props.onChange?.(e);
        }}
        inputProps={{
          autocomplete: 'none',
          'aria-label': 'Text Box'
         }}
         disabledBackground={disabledBackground}
      />
      {props.error && !!errorMessage && <StyledTextboxErrorMessage>{errorMessage}</StyledTextboxErrorMessage>}
      </Box>
  );
};

export default Textbox;
